import Typography from "@mui/material/Typography"
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import FormControl from '@mui/material/FormControl';
import TableRow from '@mui/material/TableRow';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { styled, alpha } from '@mui/material/styles';
import { Fragment, useEffect, useState } from "react"

import dynamic from "next/dynamic";
import { count, round } from "@components/config/helpers";

const GlobalButton = dynamic(() => import('@components/Components/GlobalButton/GlobalButton'))

const styles = {
  listStyleType: 'default',
}

const ListItem = ({ name, value, unit, alternativeRow}) => (
    alternativeRow ? (
        <>
          <StyledAlternativeRow>
              <TableCell><Typography className="f-size_2" component="span" variant="span" color="grey">{name}</Typography></TableCell>
              <TableCell><Typography className="f-size_2" component="span" variant="span" color="grey">{round(value)}</Typography></TableCell>
              <TableCell><Typography className="f-size_2" component="span" variant="span" color="grey">{unit}</Typography></TableCell>
          </StyledAlternativeRow>
        </>
    ) : (
      <TableRow>
        <TableCell className="border-none"><Typography className="f-size_2" component="span" variant="span" color="grey">{name}</Typography></TableCell>
        <TableCell className="border-none"><Typography className="f-size_2" component="span" variant="span" color="grey">{round(value)}</Typography></TableCell>
        <TableCell className="border-none"><Typography className="f-size_2" component="span" variant="span" color="grey">{unit}</Typography></TableCell>
      </TableRow>
    )
)

const StyledAlternativeRow = styled(TableRow)(({theme}) => ({
	'&:nth-of-type(even)': {
	  backgroundColor: alpha(theme.palette.primary.main, 0.2), //set opacity 
	  // opacity: '10%'
	},
  }))


const ProductMeasurements2 = ({width, depth, height, measurements, product}) => {

  const [unit , setUnit] = useState({height: height?.unit,depth: depth?.unit, width: width?.unit,})

  const unitValue= { cm : 'cm', mm: 'mm', M: 'm'}

    const [unit_mm, set_unit_mm]= useState(null)
    const [unit_cm, set_unit_cm]= useState(null)
    const [unit_M, set_unit_M]= useState(null)
    const [ check , setCheck ]= useState(null)
    const [ checkMetre , setCheckMetre ]= useState(null)
    const [selected, setSelected] = useState('mm');

  useEffect(()=>{

    if(unit_cm == null  && (unit?.height == unitValue.cm || unit?.depth == unitValue.cm || unit?.width ==  unitValue.cm )){
      setCheck(true)
     }

     if(unit?.height == unitValue.cm || unit?.depth == unitValue.cm || unit?.width ==  unitValue.cm){
      set_unit_cm(true)
    }

    if( unit_M == null && unit?.height == unitValue.M){
      setCheckMetre(true)
    }
    if(unit?.height == unitValue.main || unit?.depth == unitValue.main || unit?.width ==  unitValue.main){
      set_unit_M(true)
    }
  },[unit_cm, unit, unit_mm, unitValue, check])

   const handle_mm=(val)=>{
     if(val !== unitValue.mm){
       set_unit_mm(true)
       setSelected('mm')
 
      setUnit({
        height: unitValue.mm,
        width: unitValue.mm,
        depth: unitValue.mm,
      })
     }else{
      set_unit_mm(false)

     }
    
   }
   const handle_cm=(val)=>{
    
     if(val !== unitValue.cm){
       set_unit_cm(true)
        setSelected('cm')
      setUnit({
        height: unitValue.cm,
        width: unitValue.cm,
        depth: unitValue.cm,
      })
     }else{
      set_unit_cm(false)
  
     }
   }
   const handle_M=(val)=>{
     if(val !== unitValue.M){
      setSelected('m');
      set_unit_M(true)
      setUnit({
        height: unitValue.M,
        width: unitValue.M,
        depth: unitValue.M,
      })
     }else{
      set_unit_M(false)
     }
   }
   useEffect(() => {
    handle_mm(unit?.depth || unit?.height || unit?.width)
   }, [])
   

  const handleValue =(val)=>{
    

    if(checkMetre ==true  ){
     if (unit?.height == unitValue.cm || unit?.depth == unitValue.cm || unit?.width == unitValue.cm){
       return val * 100;
      }else if(unit?.height == unitValue.mm || unit?.depth == unitValue.mm || unit?.width == unitValue.mm  ){
        return val * 1000;
      }else{
         return parseFloat(val).toFixed(2);
       }
    } else if(checkMetre == null){
      if(check=== true){
       if(unit?.height == unitValue.cm || unit?.depth == unitValue.cm || unit?.width ==  unitValue.cm){
        return val
      }else if (unit?.height == unitValue.M || unit?.width == unitValue.M || unit?.depth == unitValue.M ){
        return val/1000;
      }else if(unit?.height == unitValue.mm  || unit?.width == unitValue.mm  || unit?.depth == unitValue.mm){ 
        if(unit_mm !== null){
         return val *10;
        }
      }
    }else if (check === null ){ 
     if(unit?.height == unitValue.mm || unit?.width == unitValue.mm || unit?.depth == unitValue.mm){
       return val
      }else if (unit?.height == unitValue.M || unit?.width == unitValue.M || unit?.depth == unitValue.M){
        return val/1000;
      }else if(unit?.height == unitValue.cm || unit?.width == unitValue.cm || unit?.depth == unitValue.cm   ){
      return  val / 10
     }
    }
    }
 
  }

  const handelMeasuredUnit=(val)=>{
    if(unit?.depth || unit?.height || unit?.width){
      return val = unit?.depth || unit?.height || unit?.width 
    } else{
      return val ;
    }
  }

  return (
    <>
      
        <TableContainer sx={{
          maxWidth: '500px',
        }}>
             
             <FormControl>
                <FormLabel>Choose Measurement</FormLabel>
                <RadioGroup
                  row
                  value={selected}
                >
                    <FormControlLabel value="mm" control={<Radio />} label="mm" onClick={()=>handle_mm(unit?.depth || unit?.height || unit?.width)} />
                    <FormControlLabel value="cm" control={<Radio />} label="cm"   onClick={()=> handle_cm(unit?.depth || unit?.height || unit?.width)} />
                    <FormControlLabel value="m" control={<Radio />} label="metres"      onClick={()=>handle_M(unit?.depth || unit?.height || unit?.width)} />
                </RadioGroup>
              </FormControl>
       
          <Table>
         
            <TableHead
              sx={{
                backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.2),
              }}
            >
              <TableRow>
                <TableCell className="border-none"><Typography component="span">Measurement</Typography></TableCell>
                <TableCell className="border-none"><Typography component="span">Value</Typography></TableCell>
                <TableCell className="border-none"><Typography component="span">Unit</Typography></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
          {height && <ListItem name={height.name} value={parseFloat(handleValue(height?.measurement_value)).toFixed(2)} unit={unit?.height} />}
            {width && <ListItem alternativeRow name={width.name} value={handleValue(width?.measurement_value)} unit={unit?.width} />}
            {depth && <ListItem name={depth.name} value={handleValue(depth?.measurement_value)} unit={unit?.depth} />}
            {count(Object.keys(measurements)) > 0 && (
              Object.values(measurements).map((measurement, idx) => {
                return (
                  <Fragment key={idx}>
                    <ListItem 
                    alternativeRow={idx%2 ? false : true}
                    idx={idx} 
                    name={measurement.name} 
                    value={handleValue(measurement.measurement_value)} 
                    unit={handelMeasuredUnit(measurement.unit)} />
                  </Fragment>
                )
              })
            )}
          </TableBody>
          </Table>

        </TableContainer>
    </>
      )
}

export default ProductMeasurements2